import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2018 - 2020",
      title: "BSc (Hons) in Applied Sciences (Information Systems and Web Technologies)",
      place: "The Hong Kong Polytechnic University",
      desc: "The necessary knowledge and skills for developing websites at the front-end and supporting programs and database at the back-end will be learned in this programme.",
    },
    {
      yearRange: "2016 - 2018",
      title: "Associate in Information Technology",
      place: "Hong Kong Community College",
      desc: "Generic skill and knowledge essential for the future. The knowledge I have learned in this programme is crucial to future academic pursuits or career development",
    },
    
  ];

  const experienceDetails = [
    {
      yearRange: "08/2022 - 04/2023",
      title: "Contract Programmer",
      place: "Social Welfare Department, Hong Kong",
      desc: "Designed and provided RESTful APIs with Java backend using Spring Boot framework with Spring Data MongoDB for retrieving and storing the data of social welfare cases and intakes for Client Information System for over 100 Service Centers and more than a million hits per day. Also, guided junior teammates with CI/CD tools like Git and JIRA. Provided them with technical advice, securing the progression in Agile methodology to meet the schedule.",
    },
    {
      yearRange: "03/2022 - 08/2022",
      title: "Software Engineer",
      place: "Hutchison Telecommunication Limited Hong Kong",
      desc: "Java development and web development of a POS system of over a thousand frontline salespersons. I am also responsible for the maintenance of the POS system.	Upgraded the online payment system to MPGS (Mastercard Payment Gateway System) for the POS of over a thousand frontline salespersons. ",
    },
    {
      yearRange: "09/2020 - 02/2022",
      title: "Contract Junior Programmer",
      place: "Social Welfare Department, Hong Kong",
      desc: "Redevelopment of the Client Information System of the SWD. Two main functions and some minor functions are developed by me. Enhancing over a thousand frontline social workers' user experience and testing of the program. Also, fixing the bug of the old system.",
    },
  ];

  const skills = [
    {
      name: "HTML/CSS",
      percent: 95,
    },
    {
      name: "JavaScript",
      percent: 90,
    },
    {
      name: "React JS",
      percent: 90,
    },
    {
      name: "Angular",
      percent: 95,
    },
    {
      name: "Java",
      percent: 95,
    },
    {
      name: "Python",
      percent: 80,
    },
    {
      name: "SQL",
      percent: 95,
    },
    {
      name: "Software Develop",
      percent: 90,
    },
    {
      name: "Node.js",
      percent: 80,
    },
    {
      name: "PHP",
      percent: 70,
    },
    {
      name: "C++",
      percent: 75,
    },
    {
      name: "Mobile Apps Develop",
      percent: 75,
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download Resume
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
